<template>
  <input ref="input_file" type="file" @change="selectFiles($event)" v-bind:class="classList" 
    v-bind:style="styleStr" v-bind:name="name" v-bind:id="id" v-bind:accept="accept" v-bind:capture="capture" v-bind:files="files"
  />
</template>
<script>
import axios from 'axios'
import sha1 from 'js-sha1'

import { CONFIG } from '@/config/config.js'
import SocialService from '@/services/social-service.js'
import MessagesService from '@/services/notification-service.js'

let messagesService = new MessagesService()
let socialService = new SocialService() //Iniciado sem URL_BASE, apenas para utilizar o getDeviceInfo

export default {
  name: "FileStorageUpload",
  data() {
    return {
      chosen_files: [],
      classList: this.classStr
    }
  },
  props: {
    classStr: [String, Object],
    styleStr: [String, Object],
    name: [String, Object],
    id: [String, Object],
    accept: [String, Object],
    capture: [String, Object],
    files: [String, Object],
    multiple: [String, Object, Boolean],
    ref_id: [String, Object]
  },
  methods: {
    async uploadFiles(){
      this.signalUp('startUpload', this.chosen_files)
      let payload = await this.getFilesPayload()

      if(payload.hasOwnProperty('error')){
        this.signalUp('failedUpload', {'error': payload.error})
        return false
      }

      axios.post(`${CONFIG.URL_STORAGE_API}/v2/upload/${this.ref_id}/`, payload)
      .then((response) => {
        setTimeout(() => {this.getPromiseStatus(response.data.data.StorageAPI.send_id)}, 1500)
      })
      .catch((error) => {
        this.signalUp('failedUpload', {'upload_error': error})
      })
      .finally(() => {
        this.chosen_files = []
      })
    },
    getPromiseStatus(promise_id, counts){
      let count = (counts ? counts : 1)
      if(count <= 10){
        axios.get(`${CONFIG.URL_STORAGE_API}/v2/promise/${promise_id}/`)
        .then((response) => {
          let status_promise = response.data.data.StorageAPI.send_status_code
          if(status_promise === 200){
            this.signalUp('finishedUpload', response.data.data.StorageAPI.files)
          } else {
            setTimeout(() => {this.getPromiseStatus(promise_id, (count +1))}, 1000)
          }
        }).catch((error) => {
          this.signalUp('failedUpload', {'promise_error': error})
        })
      } else {
        this.signalUp('failedUpload', {'promise_error': "Timeout"})
      }
    },
    async getFilesPayload(){
      return new Promise((resolve, reject) => {
        let files = []

        if(this.chosen_files.length > 1 && !this.multiple){
          this.chosen_files = [this.chosen_files.pop()]
        }

        this.chosen_files.forEach(async (file) => {

          if(!file.type.includes('pdf') && !file.type.includes('image')){
            resolve({error: `O arquivo ${file.name} não é permitido. Você deve utilizar apenas arquivos de imagem ou PDF!`})
            return false
          }

          let file_b64 = await this.readFileSync(file)

          files.push({
            'name': file.name,
            'mime-type': file.type,
            'upload_tipo_cod': [99],
            'sha': sha1(file_b64),
            'data': file_b64
          })

          if(files.length === this.chosen_files.length){
            resolve({
              'files': files,
              'checksum': sha1(new Date().toString()),
              'device': await socialService.getDeviceInfo()
            })
          }
        })

      })
    },
    readFileSync(file){
      let reader = new FileReader()

      reader.readAsBinaryString(file)

      return new Promise((resolve, reject) => {
        reader.onload = () => {
          resolve(btoa(reader.result))
        }
      })
    },
    signalUp(signal, data){
      this.$emit(signal, data)
    },
    selectFiles(event){
      this.signalUp('startUpload', {})
      this.chosen_files = Array.from(event.target.files)
      this.$refs.input_file.value = ""
      this.uploadFiles()
    },
    dropFiles(files){
      if(files.length > 0){
        this.chosen_files = Array.from(files)
        this.uploadFiles()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/FileStorageUpload.vue